  /* eslint-disable import/namespace */
  import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
  import userService from "../services/User.Service";

  export const userList = createAsyncThunk("users/list",async (params, thunkAPI)=> { 

      try{
        let pageData =  Object.assign({}, params.data)
        // if(pageData.page){
        //     pageData.page = pageData.page - 1  
        // }

        const data = await userService.loadUserData(pageData);
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  export const saveUser = createAsyncThunk("/user/save", async (params, thunkAPI)=>{
    try{
        const data = await userService.saveUser(params);
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }

  });

  export const getUserById = createAsyncThunk("/user/byId", async (userId, thunkAPI)=>{
    try{
        const data = await userService.getUserById(userId);
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  export const getParentUsers = createAsyncThunk("/user/parent", async ({departmentId, roleId, currentUserId = ''}, thunkAPI)=>{
    try{
        const data = await userService.getParentUsers({departmentId, roleId, currentUserId});
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  }); 

  export const getUserCount = createAsyncThunk("/user/count", async (thunkAPI) =>{
    try{
        const data = await userService.getUserCount();
        return data.data;
    }catch(exception){
        console.log(exception)
        if (!exception.response) {
          return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  export const getUserByType = createAsyncThunk("/user/type/llist", async (params, thunkAPI) =>{
    try{

        const data = await userService.getUserByType(params);
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  export const updatePassword = createAsyncThunk("/user/updatePassword", async (params, thunkAPI) =>{
    try{

        const data = await userService.updatePassword(params);
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  export const getReplacmentTeamList = createAsyncThunk("/user/getReplacmentTeamList", async ({userId}, thunkAPI) =>{
    try{

        const data = await userService.getReplacmentTeamList({userId});
        return data.data;
    }catch(exception){
        if (!exception.response) {
        return thunkAPI.rejectWithValue(exception)
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
  });

  const initialState = {
      list: [],
      totalCount: 0,
      editData: {},
      errors: false,
      success: false,
      loading: false,
      message: null,
      type: null,
      parentUser: [],
      dashboardDataUserCount: [],
      usersByType: [],
      replacmentTeamLsit: []
  }

  const UserSlice = createSlice({
    name:"UserSlice",
    initialState,
    reducers: {
      reset:() => initialState,
      resetApiStatus:(state) => {
        const editData = {}
        for(const key in state.editData){
          editData[key] = ''
        }
        return {
            list:state.list,
            totalCount: state.totalCount,
            editData,
            errors: false,
            success: false,
            loading: false,
            message: null,
            type: null,
            parentUser: [],
            dashboardDataUserCount: [],
            usersByType: [],
            replacmentTeamLsit: []
        }
      }
    },
    extraReducers:{
      [userList.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "LOADING_USER_LIST"
      },
      [userList.fulfilled] : (state, action) => {
          state.loading = false;
          state.totalCount = action.payload.totalDocs
          state.list = action.payload?.docs; 
      },    
      [userList.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.message = action.payload.errors.msg;    
      },

      [saveUser.pending] : (state) => {
          state.loading = true
          state.errors = ''
          state.success = ''
      },
      [saveUser.fulfilled] : (state, action) => {
          state.loading = false;
          const data = action.payload
          state.success = data.msg; 
      },    
      [saveUser.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          let vErrors = []
          vErrors = Array.isArray(action.payload.errors.msg)?[...new Map(action.payload.errors.msg.map(item => [item['param'], item])).values()].map((item)=>{
              return `${item.param}: ${item.msg}`
          }):action.payload.errors.msg
          state.errors = vErrors;  
      },

      [getUserById.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "LOADING_USER"
      },
      [getUserById.fulfilled] : (state, action) => {
          state.loading = false;
          state.editData = action.payload; 
      },    
      [getUserById.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.message = action.payload.errors.msg;    
      },
      
      [getParentUsers.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "FETCH_PARENT_USER_LIST"
      },
      [getParentUsers.fulfilled] : (state, action) => {
          state.loading = false;
          state.parentUser = action.payload; 
      },    
      [getParentUsers.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.message = action.payload.errors.msg;    
      },

      [getUserCount.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "FETCH_DASHBOARD_DATA"
      },
      [getUserCount.fulfilled] : (state, action) => {
          state.loading = false;
          state.dashboardDataUserCount = action.payload; 
      },    
      [getUserCount.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.message = action.payload?.errors?.msg || action.payload;    
      },

      [getUserByType.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "FETCH_DASHBOARD_DATA"
      },
      [getUserByType.fulfilled] : (state, action) => {
          state.loading = false;
          state.usersByType = action.payload; 
      },    
      [getUserByType.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.message = action.payload?.errors?.msg || action.payload;    
      },

      [updatePassword.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "UPDATE_PASSWORD_ERROR";
      },
      [updatePassword.fulfilled] : (state, action) => {
          state.loading = false;
          state.success = true;
          state.type = "UPDATE_PASSWORD_SUCCESS";
          state.message = action.payload.msg; 
      },    
      [updatePassword.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.type = "UPDATE_PASSWORD_ERROR";
          state.message = action.payload?.errors?.msg || action.payload.msg;    
      },

      [getReplacmentTeamList.pending] : (state) => {
        state.loading = true
        state.errors = false
        state.success = false
        state.type = "GET_REPLACMENT_LIST_ERROR";
      },
      [getReplacmentTeamList.fulfilled] : (state, action) => {
          state.loading = false;
          state.type = "GET_REPLACMENT_LIST_SUCCESS";
          
          state.replacmentTeamLsit = action.payload || [];
      },    
      [getReplacmentTeamList.rejected] : (state, action) => {
          state.loading = false;
          state.success = false
          state.type = "GET_REPLACMENT_LIST_ERROR";
          state.message = action.payload?.errors?.msg || action.payload.msg;    
      },

    }
  });
export const { resetApiStatus, reset } = UserSlice.actions;  
export default UserSlice.reducer;